import PickUpTab from './PickUpTab';
import { withI18n } from 'react-i18next';

export default withI18n()(PickUpTab);
